import ArrayUtil from './ArrayUtil';

export const getPaginationMap = (pageInfo, pageSize) => ({
  next: { first: pageSize, after: pageInfo.endCursor },
  prev: { last: pageSize, before: pageInfo.startCursor },
  first: { first: pageSize },
  last: { last: pageSize },
});

export const getErrors = (graphqlResponse) => {
  if (!graphqlResponse) return null;

  if (ArrayUtil.isNotEmpty(graphqlResponse.graphQLErrors)) {
    return graphqlResponse.graphQLErrors;
  }

  return [graphqlResponse];
};
